import { CallDetailsStatus } from 'features/call/call-details/enums';
import { useBaseCallDetailsStatusUpdateFromParticipants } from 'features/call/call-details/hooks';
import { setCallDetailsStatus } from 'features/call/call-details/store';
import type { CallDetailsStatusUpdateFromParticipantsData } from 'features/call/call-details/interfaces';

const getNewCallDetailsStatus = ({
  isDeafToHearing,
  deaf,
  hearing,
}: CallDetailsStatusUpdateFromParticipantsData): CallDetailsStatus => {
  if (isDeafToHearing) {
    switch (hearing.status) {
      case 'connecting':
      case 'disconnected':
        return hearing.hasConnected
          ? CallDetailsStatus.CALLEE_RECONNECT
          : CallDetailsStatus.CALLEE_DISCONNECTED;

      case 'connected':
        return CallDetailsStatus.CALLEE_CONNECTED;
    }
  } else {
    switch (deaf.status) {
      case 'connecting':
      case 'disconnected':
      case 'unavailable':
        return CallDetailsStatus.CALLEE_DISCONNECTED;

      case 'connected':
        return CallDetailsStatus.CALLEE_CONNECTED;
    }
  }
};
export const useRegularVrsCallDetailsUpdateFromParticipants = () => {
  useBaseCallDetailsStatusUpdateFromParticipants(
    setCallDetailsStatus,
    getNewCallDetailsStatus
  );
};
